// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__U-ogn","newExpiryDate":"styles_newExpiryDate__Zj6Mw","footer":"styles_footer__3fkah"};